import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gradient-to-b from-m3-surface to-m3-surface-container border-t-4 border-m3-on-surface py-12 relative overflow-hidden" data-id="element-49">
      {/* Pixel Grid Background */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: `
          linear-gradient(0deg, transparent 24%, rgba(13, 112, 128, 0.3) 25%, rgba(13, 112, 128, 0.3) 26%, transparent 27%, transparent 74%, rgba(13, 112, 128, 0.3) 75%, rgba(13, 112, 128, 0.3) 76%, transparent 77%, transparent),
          linear-gradient(90deg, transparent 24%, rgba(13, 112, 128, 0.3) 25%, rgba(13, 112, 128, 0.3) 26%, transparent 27%, transparent 74%, rgba(13, 112, 128, 0.3) 75%, rgba(13, 112, 128, 0.3) 76%, transparent 77%, transparent)
        `,
      backgroundSize: '30px 30px'
    }} data-id="element-50"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative" data-id="element-51">
        <div className="grid md:grid-cols-3 gap-8 mb-8" data-id="element-52">
          <div data-id="element-53">
            <div className="flex items-center space-x-3 mb-6" data-id="element-54">
              <motion.img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vdT4rA9mtEjYTkQ7Gc8P9V/snowday_logo_clean.svg" alt="Snow Day Logo" className="w-12 h-12 shadow-lg" whileHover={{
              scale: 1.1
            }} transition={{
              type: 'spring',
              stiffness: 400,
              damping: 10
            }} data-id="element-55" />
              <span className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-m3-on-surface to-m3-outline uppercase" data-id="element-56">
                Snow Day
              </span>
            </div>
            <p className="text-sm text-m3-on-surface-variant leading-relaxed" data-id="element-57">
              Making reading practice joyful for K-12 students everywhere.
            </p>
          </div>

          <div data-id="element-58">
            <h4 className="font-bold text-lg mb-6 text-m3-outline uppercase tracking-wider" data-id="element-59">
              Quick Links
            </h4>
            <ul className="space-y-3" data-id="element-60">
              <li data-id="element-61">
                <Link to="/" className="text-m3-on-surface hover:text-m3-outline transition-colors text-sm uppercase tracking-wide hover:translate-x-1 inline-block transform duration-200" data-id="element-62">
                  → Home
                </Link>
              </li>
              <li data-id="element-63">
                <Link to="/contact" className="text-m3-on-surface hover:text-m3-outline transition-colors text-sm uppercase tracking-wide hover:translate-x-1 inline-block transform duration-200" data-id="element-64">
                  → Contact Us
                </Link>
              </li>
              <li data-id="element-65">
                <a href="https://app.snowdayacademy.com" className="text-m3-on-surface hover:text-m3-outline transition-colors text-sm uppercase tracking-wide hover:translate-x-1 inline-block transform duration-200" data-id="element-66">
                  → Try it Now
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-67">
            <h4 className="font-bold text-lg mb-6 text-m3-outline uppercase tracking-wider" data-id="element-68">
              Get in Touch
            </h4>
            <div className="flex items-start space-x-3 text-m3-on-surface-variant" data-id="element-69">
              <MailIcon className="w-6 h-6 mt-1 flex-shrink-0 text-m3-outline" data-id="element-70" />
              <div data-id="element-71">
                <p className="mb-3 text-sm leading-relaxed" data-id="element-72">Have questions?</p>
                <Link to="/contact" className="text-m3-on-surface hover:text-m3-outline transition-colors font-bold uppercase text-sm tracking-wide" data-id="element-73">
                  Contact Team →
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t-2 border-m3-on-surface/30 pt-8 text-center" data-id="element-74">
          <p className="text-m3-on-surface text-xs uppercase tracking-widest" data-id="element-75">
            © {new Date().getFullYear()} Snow Day • Game Over? Never! • All
            Rights Reserved
          </p>
        </div>
      </div>
    </footer>;
}